import React, { useMemo } from 'react';
import type { FormRule } from 'antd';
import { Form, Select } from 'antd';
import { useGetCountries } from 'api/countries/use-get-countries.ts';
import { transformCountriesForForm } from 'shared/utils/countries';

interface ICountryFormSelectProps {
  name: string | Array<string | number>;
  placeholder?: string;
  className?: string;
  rootClassName?: string;
  rules?: FormRule[];
  onChange?: () => void;
}

export const CountryFormSelect: React.FC<ICountryFormSelectProps> = (props) => {
  const { name, rules, placeholder, className, rootClassName, onChange } = props;
  const { data: countries } = useGetCountries();
  const transformedCountries = useMemo(() => transformCountriesForForm(countries), [countries]);

  return (
    <Form.Item name={name} className={className} rootClassName={rootClassName} rules={rules}>
      <Select
        optionFilterProp='label'
        placeholder={placeholder}
        options={transformedCountries}
        showSearch
        onChange={onChange}
      />
    </Form.Item>
  );
};
